import { PkIcon } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useTranslatedEntity } from '../../hooks';
import { useNomineeEntity } from '../../hooks/useNomineeEntity';
import type { PollType } from '../../types';
import { getVideoThumbnailByFormat } from '../../utils/l10nHelper';
import { getWinnerNominee } from '../../utils/utils';

import * as style from './style.module.scss';

const Poll = ({ poll }: { poll: PollType }) => {
  const {
    i18n: { language },
  } = useTranslation();

  const { title } = useTranslatedEntity(poll);

  const winnerNominee = useMemo(() => getWinnerNominee(poll), [poll]);
  const winnerEntity = useNomineeEntity(winnerNominee);
  const thumbnail = getVideoThumbnailByFormat(winnerNominee, language, 'WIDE');

  return (
    <Link to={`/${poll.id}`}>
      <div className='pk-w--100'>
        <figure className={clsx('pk-position--relative', style.image)}>
          <PkIcon name='av-play' size='32' className={style.playIcon}></PkIcon>
          <img className='pk-w--100' src={thumbnail} alt={title} />
        </figure>
        <div className={style.pollContent}>
          <div className={style.pollTitle}>{title}</div>
          <div className={style.winnerTitle}>{winnerEntity?.name}</div>
        </div>
      </div>
    </Link>
  );
};

export default Poll;
